import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gem, AlertTriangle, Check } from 'lucide-react';
import Button from './ui/Button';

const InsufficientTokensModal = ({ isOpen, onClose, requiredTokens, currentTokens }) => {
  const navigate = useNavigate();

  const handleAcquireTokens = () => {
    navigate('/tokens');
    onClose();
  };

  if (!isOpen) return null;

  const perks = [
    'Gerar imagens com IA',
    'Experimentar roupas virtualmente',
    'Baixar resultados em alta qualidade',
    'Acessar recursos premium',
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-zinc-900 p-6 shadow-2xl">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/15">
            <AlertTriangle className="h-6 w-6 text-amber-400" />
          </div>
          <h2 className="text-xl font-semibold text-white">Tokens insuficientes</h2>
          <p className="mt-1.5 text-sm text-zinc-400">
            Você não possui tokens suficientes para gerar uma imagem
          </p>
        </div>

        <div className="mb-6 space-y-2 rounded-xl border border-white/10 bg-white/5 p-4">
          <div className="flex items-center justify-between text-sm">
            <span className="text-zinc-400">Tokens necessários</span>
            <span className="font-semibold text-white">{requiredTokens}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-zinc-400">Tokens disponíveis</span>
            <span className="font-semibold text-white">{currentTokens}</span>
          </div>
          <div className="flex items-center justify-between border-t border-white/10 pt-2 text-sm">
            <span className="text-zinc-400">Faltam</span>
            <span className="font-semibold text-amber-400">
              {requiredTokens - currentTokens}
            </span>
          </div>
        </div>

        <div className="mb-6 rounded-xl border border-rose-500/20 bg-rose-500/5 p-4">
          <p className="mb-3 flex items-center gap-2 text-sm font-medium text-white">
            <Gem className="h-4 w-4 text-rose-400" /> Com tokens você pode
          </p>
          <ul className="space-y-2">
            {perks.map((perk) => (
              <li key={perk} className="flex items-center gap-2.5 text-sm text-zinc-300">
                <Check className="h-3.5 w-3.5 shrink-0 text-emerald-400" />
                {perk}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex gap-3">
          <Button onClick={onClose} variant="secondary" fullWidth>
            Cancelar
          </Button>
          <Button onClick={handleAcquireTokens} icon={Gem} fullWidth>
            Adquirir tokens
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InsufficientTokensModal;
